<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Agregar nuevo registro</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditations/applications_historical_data/${inputs.id}`
            : `/accreditations/applications_historical_data`
        "
      >
        <div class="row">
          <div class="col-md-12 mb-5">
            <h5 class="card-title m-0">{{ "1. " + $t("Organismo, Area y Actividad") }}</h5>
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_area_id" class="col-sm-3 mb-0">
            {{ $t("Seleccionar organismo") }}
          </label>
          <app-input v-if="!selectedUrl"
            id="inputs_accreditation_area_id"
            class="col-sm-9"
            type="search-select"
            v-model="inputs.organization_id"
            :list="organization"
            :required="true"
          />
          <app-input v-if="selectedUrl"
            id="inputs_accreditation_area_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.organization_id"
            :list="organization"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_area_id" class="col-sm-3 mb-0">
            {{ $t("accreditation_area") }}
          </label>
          <app-input
            id="inputs_accreditation_area_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.accreditation_area_id"
            :list="accreditationAreaList"
            v-on:change="onChangeAccreditationArea"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_activity_id" class="col-sm-3 mb-0">
            {{ $t("activity") }}
          </label>
          <app-input
            id="inputs_accreditation_activity_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.accreditation_activity_id"
            :list="accreditationActivityLists"
            :required="true"
          />
        </div>
        <!-- <div class="row">
          <div class="col-md-12 mb-5">
            <hr />
            <h5 class="card-title m-0">
              {{ "2. " + $t("Tipo de registro") }}
            </h5>
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_type_id" class="col-sm-3 mb-0">
            {{ $t("Tipo") }}
          </label>
          <app-input
            id="inputs_accreditation_type_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.accreditation_type_id"
            :list="accreditationTypeList"
            :required="true"
          />
        </div> -->

        <div class="row">
          <div class="col-md-12 mb-5">
            <hr />
            <h5 class="card-title m-0">
              {{ "2. " + $t("Número de expediente") }}
            </h5>
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_type_id" class="col-sm-3 mb-0">
            {{ $t("Nro de expediente") }}
          </label>
          <app-input
            id="inputs_accreditation_type_id"
            class="col-sm-9"
            type="text"
            v-model="inputs.record"
            :required="true"
          />
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "../../../../../../../resources/js/app/helpers/AxiosHelper";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationAreaList: Array,
    accreditationActivityList: Array,
    accreditationTypeList: Array,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      organization: [],
      modalId: "application-add-edit-modal",
      modalTitle: this.$t("accreditation") + " / " + this.$t("new_request"),
      accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
      formRowInstruction: [this.$t("type_request")],
      disabledSubmit: false,
    };
  },
  created() {
    this.orgList();
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.inputs.accreditation_type_id = 100;
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    orgList() {
      axiosGet("/masterData/agreements/organizationList").then((response) => {
        this.organization = response.data;
      });
    },

    afterSuccess({ data: res }) {
      // this.$toastr.s(response.data.message);
      if (res.status == true) {
        this.$toastr.s(this.$t("created_success"));
        this.$hub.$emit("reload-" + this.tableId);
      } else {
        this.$toastr.e(
          "Ocurrió un inconveniente, por favor contacte a su administrador de sistema"
        );
      }
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.onChangeAccreditationArea();
      this.preloader = false;
    },
    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.accreditation_area_id;
        }),
      ];
    },
  },
};
</script>
